export enum ConnectionState {
    Disconnected = "disconnected",
    Connecting = "connecting",
    Authenticating = "authenticating",
    ConnectedUnverified = "connected_unverified",
    Syncing = "syncing",
    Ready = "ready",
    Degraded = "degraded",
}

export type RecoveryTracker = {
    retryCount: number;
    nextRetryAt: number | null;
    lastError: string | null;
};

